import { useDataMutation } from "@Libs/DataLayer/hooks/useDataMutation";

import {
  ICreateUserSessionInput,
  IRegisterUserInput,
  IUserAvailability,
  IUserSession,
  createUserSession,
  getEmailSuggestion,
  getUserAvailability,
  registerUser,
} from "../services/emailLogin";
import {
  ICreateSsoSessionInput,
  createSsoSession,
} from "../services/ssoLogin";

/**
 * Mutations, not queries: each runs on submit, and an address checked a minute
 * ago may have been registered since. Reading a rejection is the service's job.
 */

export const useUserAvailability = () =>
  useDataMutation<IUserAvailability, unknown, string>(getUserAvailability);

export const useCreateUserSession = () =>
  useDataMutation<IUserSession, unknown, ICreateUserSessionInput>(
    createUserSession
  );

export const useRegisterUser = () =>
  useDataMutation<IUserSession, unknown, IRegisterUserInput>(registerUser);

/** Advisory, so it never rejects: a failed check means no suggestion. */
export const useEmailSuggestion = () =>
  useDataMutation<string | undefined, unknown, string>((email) =>
    getEmailSuggestion(email).catch(() => undefined)
  );

export const useCreateSsoSession = () =>
  useDataMutation<IUserSession, unknown, ICreateSsoSessionInput>(
    createSsoSession
  );
